import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import InvoiceFinanceCharges from "./InvoiceFinanceCharges";

const InvoiceFinanceChargesPage = () => {
  return (
    <NavHeightAdjust>
      <InvoiceFinanceCharges />
    </NavHeightAdjust>
  );
};

export default InvoiceFinanceChargesPage;
